import { useEffect } from 'react';
import i18n from 'i18next';

import { DEFAULT_LANGUAGE } from '~/config/translations';

/** Clé lue par la page hors-ligne de la PWA animateur (public/animator-offline.html). */
const OFFLINE_LANG_KEY = 'animatorLang';

/**
 * Cale la console sur la langue de l'établissement piloté.
 *
 * La zone `/animator` ne passe pas par `/home` (le seul endroit qui applique
 * `clients/{id}.lang`) : l'animateur y arrive en direct par QR, raccourci PWA ou
 * lien. Sans ce hook, i18next reste sur la langue du NAVIGATEUR — un bar anglais
 * dont l'animateur a un téléphone en français lirait un cockpit français.
 *
 * Effet de bord voulu : on mémorise la langue résolue dans `localStorage`, seule
 * source disponible à la page hors-ligne du service worker (aucun réseau, donc
 * aucun accès à Firestore). Accès protégé : lire `localStorage` **jette** sur un
 * téléphone qui bloque les données de site (gotcha #176).
 */
export function useAnimatorLanguage(language?: string) {
    useEffect(() => {
        if (language && language !== i18n.language) i18n.changeLanguage(language);
    }, [language]);

    useEffect(() => {
        try {
            window.localStorage.setItem(OFFLINE_LANG_KEY, i18n.resolvedLanguage || DEFAULT_LANGUAGE);
        } catch {
            /* stockage bloqué : la page hors-ligne retombera sur la langue du navigateur */
        }
    }, [language]);
}
